export default __webpack_public_path__ + "static/media/businessCenterLight.fb982b7b.svg";